



























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class UserOnlineBody extends Vue {
  @Prop() readonly data!: object;
}
